import React, { forwardRef, memo } from 'react'

const MixedFruitsIcon = forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>((props, ref) => (
  <svg
    ref={ref}
    width="154.7"
    height="170.1"
    viewBox="0 0 154.7 170.1"
    fill="none"
    {...props}>
    <circle
      cx="81.862"
      cy="32.985"
      r="23.333"
      transform="rotate(43.4223 81.862 32.985)"
      fill="#D15A19"
    />
    <mask
      id="mask0"
      maskUnits="userSpaceOnUse"
      x="58.1"
      y="9.1"
      width="47.6"
      height="47.6">
      <circle
        cx="81.862"
        cy="32.985"
        r="23.333"
        transform="rotate(43.4223 81.862 32.985)"
        fill="#C27C00"
      />
    </mask>
    <g mask="url(#mask0)">
      <path
        d="M73.986 10.344L81.432 17.391"
        stroke="white"
        strokeWidth="1.025"
      />
      <path
        d="M57.859 30.369L65.305 37.416"
        stroke="white"
        strokeWidth="1.025"
      />
      <path
        d="M61.103 16.501L70.41 25.309"
        stroke="white"
        strokeWidth="1.025"
      />
    </g>
    <ellipse
      cx="84.85"
      cy="36.153"
      rx="21.529"
      ry="23.579"
      transform="rotate(43.4223 84.85 36.153)"
      fill="#FFA300"
    />
    <circle
      cx="47.208"
      cy="119.644"
      r="33.285"
      transform="rotate(52.6982 47.208 119.644)"
      fill="#D15A19"
    />
    <mask
      id="mask1"
      maskUnits="userSpaceOnUse"
      x="13.3"
      y="85.9"
      width="67.2"
      height="67.2">
      <circle
        cx="47.208"
        cy="119.644"
        r="33.285"
        transform="rotate(52.6982 47.208 119.644)"
        fill="#C27C00"
      />
    </mask>
    <g mask="url(#mask1)">
      <path
        d="M41.326 85.958L50.189 97.592"
        stroke="white"
        strokeWidth="1.463"
      />
      <path
        d="M14.015 110.441L22.878 122.074"
        stroke="white"
        strokeWidth="1.463"
      />
      <path
        d="M21.771 91.663L32.85 106.205"
        stroke="white"
        strokeWidth="1.463"
      />
    </g>
    <ellipse
      cx="50.687"
      cy="124.791"
      rx="30.712"
      ry="33.637"
      transform="rotate(52.6982 50.687 124.791)"
      fill="#FFA300"
    />
    <circle
      cx="114.088"
      cy="91.538"
      r="27.542"
      transform="rotate(52.6982 114.088 91.538)"
      fill="#D15A19"
    />
    <mask
      id="mask2"
      maskUnits="userSpaceOnUse"
      x="86.1"
      y="63.7"
      width="56"
      height="56">
      <circle
        cx="114.088"
        cy="91.538"
        r="27.542"
        transform="rotate(52.6982 114.088 91.538)"
        fill="#C27C00"
      />
    </mask>
    <g mask="url(#mask2)">
      <path
        d="M109.22 63.664L116.554 73.291"
        stroke="white"
        strokeWidth="1.21"
      />
      <path
        d="M86.622 83.925L93.956 93.552"
        stroke="white"
        strokeWidth="1.21"
      />
      <path
        d="M93.041 68.385L102.208 80.418"
        stroke="white"
        strokeWidth="1.21"
      />
    </g>
    <ellipse
      cx="116.966"
      cy="95.798"
      rx="25.413"
      ry="27.834"
      transform="rotate(52.6982 116.966 95.798)"
      fill="#FFA300"
    />
  </svg>
))

MixedFruitsIcon.displayName = 'MixedFruitsIcon'

export default memo(MixedFruitsIcon)
